import { t } from '@ardoq/i18n';
import { useFormattingContext } from './useFormattingContext';
import { HelpText } from '../HelpText';

export const AddNewFormattingGroupHelpText = () => {
  const { i18nLocale } = useFormattingContext();

  return (
    <HelpText>
      {t(
        i18nLocale,
        'perspectives:addNewFormattingRuleButton.helpText',
        'Conditional formatting will appear in the order selected here'
      )}
    </HelpText>
  );
};
